export function LogoMark({ className = "h-9 w-9" }) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect
        width="64"
        height="64"
        rx="14"
        fill="#0A0A0A"
        stroke="rgba(0,0,0,0.08)"
      />
      <circle cx="26" cy="32" r="18" fill="none" stroke="#E8EAED" strokeWidth="5" strokeDasharray="2.5 5.8" />
      <circle cx="26" cy="32" r="13" fill="none" stroke="#E8EAED" strokeWidth="2.5" />
      <circle cx="26" cy="32" r="3.2" fill="#E8EAED" />
      <path
        d="M39 9 22 37h9l-4 18 19-29H35.5L39 9z"
        fill="#33A6FF"
        stroke="#0A0A0A"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-3">
      <LogoMark />
      {!compact && (
        <span className="font-display font-extrabold tracking-tight text-ink leading-none">
          <span className="block text-[15px]">AKL</span>
          <span className="block text-[15px] text-volt">E-KITS</span>
        </span>
      )}
    </span>
  );
}
